import { IRoute } from "@/common/interfaces";

import { AgendaRoutes } from "../modules/agenda/routes/routes";
import { AuthRoutes } from "../modules/auth/routes/routes";
import { BuildingRoutes } from "../modules/building/routes/routes";
import { CandidateRoutes } from "../modules/candidate/routes/routes";
import { ConfirmationRoutes } from "../modules/confirmation/routes/routes";
import { DashboardRoutes } from "../modules/dashboard/routes/routes";
import { DwellingRoutes } from "../modules/dwelling/routes/routes";
import { MyTeamRoutes } from "../modules/myTeam/routes/routes";
import { OrderRoutes } from "../modules/order/routes/routes";
import { OrdersRoutes } from "../modules/orders/routes/routes";
import { ProfileRoutes } from "../modules/profile/routes/routes";
import { RGPDRoutes } from "../modules/rgpd/routes/routes";
import { ServiceOrderingRoutes } from "../modules/serviceOrdering/routes/routes";
import { SupportRoutes } from "../modules/support/routes/routes";


const Routes: IRoute[] = [];

const DefaultRoutes: any = [
  ...AgendaRoutes,
  ...AuthRoutes,
  ...BuildingRoutes,
  ...CandidateRoutes,
  ...DashboardRoutes,
  ...DwellingRoutes,
  ...MyTeamRoutes,
  ...OrdersRoutes,
  ...ProfileRoutes,
  ...ServiceOrderingRoutes,
  ...SupportRoutes,
  ...RGPDRoutes,
  ...OrderRoutes,
  ...ConfirmationRoutes,
  ...Routes,
];

export default DefaultRoutes;
